module.exports = __webpack_public_path__ + "static/expert-with-patient@2x-67c90f45abcbdb1dfa732cdbe50e6770.png";